module.exports = __webpack_public_path__ + "images/bedrijfswagenleasing_small8bb05e6cf1ba6ab0adaae979e2379e0d.png";